import { AppStore } from "@/store/AppStore";
import { FeedbackModelData } from "@/store/feedback/types";
import { SessionEventModelData } from "@/store/sessions/types";
import { SyncUpdateValue } from "@/store/sync/types";
import Dexie from "dexie";

export const searchSessionEventsForSession = async ({
  store,
  sessionId,
}: {
  store: AppStore;
  sessionId: string;
}): Promise<SessionEventModelData[]> => {
  const events = await store.sessionEvents.localTable
    .where("[session_id+locally_created_at+model_id]")
    .between([sessionId, Dexie.minKey], [sessionId, Dexie.maxKey])
    .reverse()
    .toArray();

  const eventIds = events.map(event => event.model_id);

  const feedbacks = await store.feedback.getFeedbackByAssociatedModelId({
    associatedModelIds: eventIds,
    associatedModelKind: "SESSION_EVENT",
    feedbackKind: "MEM_IT_RESPONSE",
  });

  return events.map(event => ({
    ...event.model_data,
    feedback_given: getFeedbackGiven(event.model_id, feedbacks),
  }));
};

const getFeedbackGiven = (
  eventId: string,
  feedbacks: SyncUpdateValue<FeedbackModelData>[]
): "UPVOTE" | "DOWNVOTE" | null => {
  const feedback = feedbacks.find(feedback => feedback.model_data.associated_model_id === eventId);
  if (!feedback) {
    return null;
  }

  return feedback.model_data.feedback_response;
};
